module.exports = __webpack_public_path__ + "static/VSMist-ade7591fbbd8d3c8e940be5e3d637166.jpg";